import React from 'react'
import EnquiryForm from '../components/publicWebsite/enquiryForm/EnquiryForm'
const EnquiryPage = () => {
  return (
    <div>
      <div className='pt-2 pb-2 mt-5 mb-5'>
      </div>
       <EnquiryForm />
    </div>
  )
}


export default EnquiryPage

